module.exports = __webpack_public_path__ + "3066c5e3b4c96672e0bb9f273d88bcb9.svg";